module.exports = __webpack_public_path__ + "static/img/b1-5-1.568cff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-5-1.png
// module id = 4oLn
// module chunks = 1